/* JOM — Editorial Dropdown v1.1
   Injects an editorial atmosphere panel into the "Sobre" navigation submenu.
   Configure IMAGE_SRC with your Shopify CDN image URL, or leave empty for the gradient fallback.
   v1.1: detection via stable Horizon ID (#MenuItem-sobre) instead of text content.
*/
(function () {

  var IMAGE_SRC = '';

  function buildFigure() {
    var figure = document.createElement('figure');
    figure.className = 'jom-editorial-figure';
    figure.setAttribute('aria-hidden', 'true');

    if (IMAGE_SRC) {
      var img = document.createElement('img');
      img.className = 'jom-editorial-img';
      img.src = IMAGE_SRC;
      img.loading = 'lazy';
      img.decoding = 'async';
      img.alt = '';
      figure.appendChild(img);
    }

    return figure;
  }

  function enhance() {
    var items = document.querySelectorAll(
      '.header-menu .menu-list__list-item:not([slot="overflow"])'
    );

    items.forEach(function (item) {
      if (!item.querySelector('#MenuItem-sobre')) return;

      var submenu = item.querySelector(':scope > .menu-list__submenu');
      if (!submenu || submenu.hasAttribute('data-jom-editorial')) return;

      var inner = submenu.querySelector('.menu-list__submenu-inner');
      if (!inner) return;

      submenu.setAttribute('data-jom-editorial', 'sobre');
      inner.insertBefore(buildFigure(), inner.firstChild);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance);
  } else {
    enhance();
  }
})();
